import { useRef } from 'react'

interface NewRecipeStepProps {
  newStep: () => void
}

function NewRecipeStep({ newStep }: NewRecipeStepProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  const handleNewStep = () => {
    newStep()

    // Scroll to bottom after adding new step
    setTimeout(() => {
      if (containerRef.current) {
        const scrollableParent = containerRef.current.closest(
          '.collapsible-section-content'
        )
        if (scrollableParent) {
          scrollableParent.scrollTop = scrollableParent.scrollHeight
        }
      }
    }, 0)
  }

  return (
    <div className="new-recipe-list-item" ref={containerRef}>
      <button
        className="new-recipe-list-item-add-button"
        onClick={handleNewStep}
      >
        +
      </button>
    </div>
  )
}

export default NewRecipeStep
